/**
 * Phase 3c — Launch promo + flash credits + notifications API helpers.
 */
import { api } from "@/lib/api";

export async function getLaunchPromoStatus() {
    const res = await api.get("/me/launch-promo/status");
    return res.data;
}

export async function activateLaunchPromo() {
    const res = await api.post("/me/launch-promo/activate");
    return res.data;
}

export async function getFlashCredits() {
    const res = await api.get("/me/flash-credits");
    return res.data;
}

export async function applyFlashCredit(post_id) {
    const res = await api.post("/me/flash-credits/apply", { post_id });
    return res.data;
}

export async function listNotifications({ unread_only = false, limit = 20, offset = 0 } = {}) {
    const res = await api.get(
        `/me/notifications?unread_only=${unread_only}&limit=${limit}&offset=${offset}`,
    );
    return res.data;
}

export async function markNotificationRead(id) {
    const res = await api.post(`/me/notifications/${id}/read`);
    return res.data;
}

export async function markAllNotificationsRead() {
    const res = await api.post("/me/notifications/read-all");
    return res.data;
}

export async function adminGrantFlashCredits(user_id, credits) {
    const res = await api.post(`/admin/users/${user_id}/grant-flash-credits`, { credits });
    return res.data;
}

export async function adminGrantLaunchPromo(user_id, { force = false, note = null } = {}) {
    const res = await api.post(`/admin/users/${user_id}/grant-launch-promo`, { force, note });
    return res.data;
}
